/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Overlap_TextInputs */

const en_subtitle_import_overlap_text = /** @type {(inputs: Subtitle_Import_Overlap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The subtitle file you are importing has overlapping events. Would you like to fix them?`)
};

const fr_subtitle_import_overlap_text = /** @type {(inputs: Subtitle_Import_Overlap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le fichier de sous-titres que vous importez contient des evenements qui se chevauchent. Voulez-vous les corriger ?`)
};

const de_subtitle_import_overlap_text = /** @type {(inputs: Subtitle_Import_Overlap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die importierte Untertiteldatei enthält überlappende Ereignisse. Möchten Sie diese beheben?`)
};

const it_subtitle_import_overlap_text = /** @type {(inputs: Subtitle_Import_Overlap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il file dei sottotitoli che stai importando presenta eventi sovrapposti. Vuoi correggerli?`)
};

const ru_subtitle_import_overlap_text = /** @type {(inputs: Subtitle_Import_Overlap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В импортируемом файле субтитров присутствуют наложения событий. Хотите ли вы их исправить?`)
};

const es_subtitle_import_overlap_text = /** @type {(inputs: Subtitle_Import_Overlap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El archivo de subtítulos que estás importando tiene eventos superpuestos. ¿Quieres corregirlos?`)
};

const zh_cn2_subtitle_import_overlap_text = /** @type {(inputs: Subtitle_Import_Overlap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您导入的字幕文件存在重叠事件。是否要修复这些问题？`)
};

const ja_subtitle_import_overlap_text = /** @type {(inputs: Subtitle_Import_Overlap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポート中の字幕ファイルには重複したイベントがあります。修正しますか？`)
};

const hi_subtitle_import_overlap_text = /** @type {(inputs: Subtitle_Import_Overlap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप जिस सबटाइटल फ़ाइल को इंपोर्ट कर रहे हैं, उसमें कुछ इवेंट ओवरलैप हो रहे हैं। क्या आप उन्हें ठीक करना चाहेंगे?`)
};

const pt_pt2_subtitle_import_overlap_text = /** @type {(inputs: Subtitle_Import_Overlap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O arquivo de legendas que você está importando contém eventos sobrepostos. Deseja corrigi-los?`)
};

/**
* | output |
* | --- |
* | "The subtitle file you are importing has overlapping events. Would you like to fix them?" |
*
* @param {Subtitle_Import_Overlap_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_overlap_text = /** @type {((inputs?: Subtitle_Import_Overlap_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Overlap_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_overlap_text(inputs)
	if (locale === "de") return de_subtitle_import_overlap_text(inputs)
	if (locale === "it") return it_subtitle_import_overlap_text(inputs)
	if (locale === "ru") return ru_subtitle_import_overlap_text(inputs)
	if (locale === "es") return es_subtitle_import_overlap_text(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_overlap_text(inputs)
	if (locale === "ja") return ja_subtitle_import_overlap_text(inputs)
	if (locale === "hi") return hi_subtitle_import_overlap_text(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_overlap_text(inputs)
	return en_subtitle_import_overlap_text(inputs)
});